<template>
    <div class="card-user-input big-card-block block-card card-border ">
        <v-expansion-panel expand :value="panel">
            <v-expansion-panel-content :lazy="true">
                <template v-slot:header >
                    <div class="block-card-title handle" >
                        <div class="title-icon">
                            <img src="../../../../assets/img/ic_r_forms@2x.png" alt="">
                        </div>

                        <h4>User Input</h4>
                    </div>
                </template>

                <div class="block-card-body">
                    <div
                        class="nested-card user-input-item delete-wrapper"
                        v-for="(item, index) in data.items"
                    >
                        <v-layout row wrap>
                            <v-flex xs6>
                                <label>Message To User</label>
<!--                                <v-text-field-->
<!--                                        outline-->
<!--                                        v-model="item.message"-->
<!--                                        :error="!item.message"-->
<!--                                        :error-messages="!item.message? 'Message To User is Required':'' "-->
<!--                                >-->
<!--                                </v-text-field>-->
                                <vTextareaAutocomplete v-model="item.message" :type="'textfield'"
                                                       :validationRules="autocompleteUserInputMessageValidationRules"></vTextareaAutocomplete>
                            </v-flex>
                            <v-flex xs6>
                                <label>Save Answer To Attribute</label>
                                <v-text-field
                                        outline
                                        v-model="item.save_to_attribute"
                                        :error="!item.save_to_attribute"
                                        :error-messages="!item.save_to_attribute? 'Attribute is Required':'' "
                                >
                                </v-text-field>

                            </v-flex>
                            <v-flex xs6>
                                <label>Validation</label>
                                <v-autocomplete
                                        :items="validationList"
                                        item-text="name"
                                        item-value="value"
                                        v-model="item.validation"
                                        :error="!item.validation"
                                        :error-messages="!item.validation? 'Validation is Required':'' "
                                        outline
                                        solo
                                ></v-autocomplete>
                            </v-flex>
                            <v-flex xs6>
                                <div v-if="item.validation === 'userAttribute'">
                                    <label>Select User Attribute</label>
                                    <vTextareaAutocomplete
                                            outline
                                            solo
                                            :items="variables"
                                            :type="'textfield'"
                                            item-text="variable"
                                            item-value="variable"
                                            v-model="item.userAttribute"
                                            :error="!item.userAttribute"
                                            :error-messages="!item.userAttribute? 'Attribute is Required':'' "
                                    >
                                    </vTextareaAutocomplete>
                                </div>
                                <div v-if="item.validation === 'other'">
                                    <label>Regex</label>
                                    <v-text-field
                                            outline
                                            v-model="item.regex"
                                            :error="!item.regex"
                                            :error-messages="!item.regex? 'Regex is Required':'' "
                                    >
                                    </v-text-field>
                                </div>
                            </v-flex>
                            <v-flex xs12>
                                <label>Error Message</label>
<!--                                <v-text-field-->
<!--                                        outline-->
<!--                                        v-model="item.errorMsg"-->
<!--                                        :error="!item.errorMsg"-->
<!--                                        :error-messages="!item.errorMsg? 'Error Message is Required':'' "-->
<!--                                >-->
<!--                                </v-text-field>-->
                                <vTextareaAutocomplete v-model="item.errorMsg" :type="'textfield'"
                                                       :validationRules="autocompleteUserErrorMessageValidationRules"></vTextareaAutocomplete>
                            </v-flex>
                        </v-layout>
                        <v-btn
                                @click="deleteUserInput(index)"
                                v-if="index>0"
                                fab small color=""
                                class="delete-button"
                        ><v-icon small color="#666">delete_outline</v-icon></v-btn>
                    </div>
                    <div class="text-xs-center">
                        <v-btn
                                large round flat
                                class="primary--text x-large-button"
                                @click="addUserAttribute"
                        >
                            <v-icon>add_circle_outline</v-icon>
                            Add User Input
                        </v-btn>
                    </div>
                </div>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </div>
</template>

<script>
    import common from "../../../../utils/common"
    export default {
        name: "card-image-url",
        props: {
            data: {
                type: Object,
                default: ()=> {
                    return {}
                }
            },
            index: {
                type: Number,
                default: ()=> {
                    return 0
                }
            },
            blocksList: {
                type: Array,
                default: ()=> {
                    return []
                }
            }
        },
        data() {
            return {
                valid: true,
                panel: 1,
                common,
                validationList: [
                    {name:'Text', value: 'text'},
                    {name:'Number', value: 'number'},
                    {name:'Email', value: 'email'},
                    {name:'User Attribute', value: 'userAttribute'},
                    {name:'Other', value: 'other'}
                ],
                autocompleteUserInputMessageValidationRules: [
                    v => !!v || 'Message to user is Required'
                ],
                autocompleteUserErrorMessageValidationRules: [
                    v => !!v || 'Error Message is Required'
                ]
            }
        },
        mounted() {

        },
        methods: {
            deleteUserInput(index) {
                this.data.items.splice(index, 1)
            },
            addUserAttribute() {
                this.data.items.push({
                    message:'',
                    validation:'',
                    save_to_attribute:'',
                    userAttribute: '',
                    regex:'',
                    errorMsg: ''
                })
            }
        },
        computed: {
            variables() {
                return this.$store.state.blocksBuild.variables
            }
        },
        watch: {

        }
    }
</script>

<style scoped>

</style>